var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-lg leading-6 font-medium text-secondaryColor mb-4"},[_vm._v("\n        "+_vm._s(_vm.value.label)+"\n    ")]),_c('p',{staticClass:"break-words",domProps:{"innerHTML":_vm._s(_vm.value.value)}},[_vm._v(_vm._s(_vm.value.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }